import { HanAccountColumns } from '@/backend/features/health-alerts/entities/Account';
import { ExtendedAccountFilterData } from '@/ui/features/contact-management/components/AccountsPanel/hooks/useOverrideMapAccountFilter';
import { AccountColumns } from '@juvare/contact-management/backend/features/accounts/shared';
import { findFilterValue, mapAccountFilterReverse } from '@juvare/contact-management/ui/features/groups/utils/mapAccountFilterReverse';
import { useOverrideMapCredentialingAccountFilter } from '@juvare/credentialing/ui/hooks';
import { DynamicColumnDefinitions } from '@juvare/platform-sdk-react/ui/components/EntityTable/dynamicColumns';
import { Filter } from '@juvare/platform-shared/features/storage';

export const useOverrideMapAccountFilterReverse = () => {
    const { overrideMapCredentialingAccountFilterReverse } = useOverrideMapCredentialingAccountFilter();
    const overrideMapAccountFilterReverse = (
        filters: Filter<HanAccountColumns>[],
        dynamicColumnData?: DynamicColumnDefinitions,
    ): ExtendedAccountFilterData => {
        const result: ExtendedAccountFilterData = {
            ...mapAccountFilterReverse(filters as Filter<AccountColumns>[], dynamicColumnData),
            ...overrideMapCredentialingAccountFilterReverse(filters as Filter<AccountColumns>[]),
        };

        result.hanRoles = findFilterValue(filters, 'hanRoles', 'overlap', 'array');
        result.outsideState = findFilterValue(filters, 'outsideState', '=', 'boolean');

        return result;
    };

    return { overrideMapAccountFilterReverse };
};
